import { Fragment, useState } from 'react'
import { useSelector } from 'react-redux'
import { Responsive } from '../common/Responsive'
import useDidUpdateEffect from '../common/hooks/useDidUpdateEffect'
import { Element } from '../common/html/element'
import { selectPostLogin } from '../layout/store/slice'
import { AuthorizationLayout } from './common/html/AuthorizationLayout'
import { CreditRisk } from './components/creditRisk'
import { CurrentPlan } from './components/currentPlan'
import { Interested } from './components/interested'
import { LatestReports } from './components/latestReports/panel'
import { News } from './components/news'
import { RecentlyAndPopular } from './components/recentlyAndPopular'
import { TotalAlerts } from './components/totalAlerts'
import { YourPortfolio } from './components/yourPorfolio'
import './lang/i18n'

const MAX_HEIGHT_FIRST_ROW = 568
const MAX_HEIGHT_SECOND_ROW = 324

export const Dashboard = () => {
  const [keyFirstLogin, setKeyFirstLogin] = useState(undefined)

  const postLogin = useSelector(selectPostLogin)

  const renderContent = (isResponsive = true) => {
    const HALF_BETWEEN_ITEMS = isResponsive ? 4 : 8

    return (
      <Element
        className="wh100 flexColumn"
        style={{
          backgroundColor: '#E5E5E5',
          padding: isResponsive ? '10px 12px' : '20px 24px',
        }}
      >
        <div
          className="dFlex w100"
          style={{
            marginBottom: HALF_BETWEEN_ITEMS,
            height: '64%',
            maxHeight: MAX_HEIGHT_FIRST_ROW,
          }}
        >
          <div
            style={{
              width: isResponsive
                ? `calc(30% - ${HALF_BETWEEN_ITEMS}px)`
                : `calc(25% - ${HALF_BETWEEN_ITEMS}px)`,
              marginRight: HALF_BETWEEN_ITEMS,
            }}
          >
            <News />
          </div>
          <div
            className="flexColumn h100"
            style={{
              width: isResponsive
                ? `calc(70% - ${HALF_BETWEEN_ITEMS}px)`
                : `calc(75% - ${HALF_BETWEEN_ITEMS}px)`,
              marginLeft: HALF_BETWEEN_ITEMS,
            }}
          >
            <div
              className="dFlex"
              style={{
                marginBottom: HALF_BETWEEN_ITEMS,
                height: '52%',
              }}
            >
              <div
                style={{
                  width: isResponsive ? 'calc(400%/7)' : 'calc(200%/3)',
                  marginRight: HALF_BETWEEN_ITEMS,
                }}
              >
                <RecentlyAndPopular />
              </div>
              <div
                style={{
                  width: isResponsive ? 'calc(300%/7)' : 'calc(100%/3)',
                  marginLeft: HALF_BETWEEN_ITEMS,
                }}
              >
                <AuthorizationLayout
                  id="currentPlan"
                  title="dashboard.currentPlan.title"
                >
                  <CurrentPlan />
                </AuthorizationLayout>
              </div>
            </div>
            <div
              className="dFlex"
              style={{
                marginTop: HALF_BETWEEN_ITEMS,
                height: '48%',
              }}
            >
              <div
                style={{
                  width: isResponsive ? 'calc(400%/7)' : 'calc(200%/3)',
                  marginRight: HALF_BETWEEN_ITEMS,
                }}
              >
                <AuthorizationLayout
                  id="riskDistribution"
                  title="dashboard.creditRisk.title"
                >
                  <CreditRisk />
                </AuthorizationLayout>
              </div>
              <div
                style={{
                  width: isResponsive ? 'calc(300%/7)' : 'calc(100%/3)',
                  marginLeft: HALF_BETWEEN_ITEMS,
                }}
              >
                <AuthorizationLayout
                  id="yourPortfolio"
                  title="dashboard.yourPortfolio.title"
                >
                  <YourPortfolio />
                </AuthorizationLayout>
              </div>
            </div>
          </div>
        </div>
        <div
          className="dFlex w100"
          style={{
            marginTop: HALF_BETWEEN_ITEMS,
            height: '36%',
            maxHeight: MAX_HEIGHT_SECOND_ROW,
          }}
        >
          <div
            style={{
              width: isResponsive
                ? `calc(30% - ${HALF_BETWEEN_ITEMS}px)`
                : `calc(25% - ${HALF_BETWEEN_ITEMS}px)`,
              marginRight: HALF_BETWEEN_ITEMS,
            }}
          >
            <AuthorizationLayout
              id="latestReportsByFiinGroup"
              title="dashboard.latestReport.latestReport"
            >
              <LatestReports />
            </AuthorizationLayout>
          </div>
          <div
            style={{
              width: isResponsive
                ? `calc(40% - ${HALF_BETWEEN_ITEMS * 2}px)`
                : `calc(50% - ${HALF_BETWEEN_ITEMS * 2}px)`,
              marginLeft: HALF_BETWEEN_ITEMS,
              marginRight: HALF_BETWEEN_ITEMS,
            }}
          >
            <AuthorizationLayout
              id="youMayBeAlsoInterestedIn"
              title="dashboard.interested.title"
            >
              <Interested />
            </AuthorizationLayout>
          </div>
          <div
            style={{
              width: isResponsive
                ? `calc(30% - ${HALF_BETWEEN_ITEMS}px)`
                : `calc(25% - ${HALF_BETWEEN_ITEMS}px)`,
              marginLeft: HALF_BETWEEN_ITEMS,
            }}
          >
            <AuthorizationLayout
              id="totalAlert"
              title="dashboard.totalAlert.title"
            >
              <TotalAlerts />
            </AuthorizationLayout>
          </div>
        </div>
      </Element>
    )
  }

  useDidUpdateEffect(() => {
    setKeyFirstLogin(!!postLogin?.isFirstLogin)
  }, [!!postLogin?.isFirstLogin])

  return (
    <Fragment key={keyFirstLogin}>
      <Responsive renderResponsive={renderContent}>
        {renderContent(false)}
      </Responsive>
    </Fragment>
  )
}

export default Dashboard
